import { useEffect, useMemo, useState } from "react";
import api from "@/lib/api";
import { logger } from "@/lib/logger";
import { useSEO } from "@/lib/useSEO";

export default function FAQPage() {
  useSEO({
    title: "FAQ",
    description: "Common questions about printing, artwork upload, turnaround, shipping, and refunds.",
    breadcrumbs: [{ name: "Home", url: "/" }, { name: "FAQ", url: "/faq" }],
  });
  const [faqs, setFaqs] = useState([]);
  useEffect(() => {
    let cancelled = false;
    api.get("/faqs")
      .then(r => { if (!cancelled) setFaqs(r.data); })
      .catch(err => logger.error("FAQ load failed:", err));
    return () => { cancelled = true; };
  }, []);
  const categories = useMemo(() => [...new Set(faqs.map(f => f.category))], [faqs]);
  const grouped = useMemo(() => {
    const m = {};
    for (const f of faqs) { (m[f.category] = m[f.category] || []).push(f); }
    return m;
  }, [faqs]);
  return (
    <section className="max-w-[1000px] mx-auto px-6 md:px-12 py-16 md:py-24">
      <p className="text-xs font-mono tracking-[0.3em] uppercase text-[#C5A059]">FAQ</p>
      <h1 className="font-serif text-5xl md:text-7xl mt-3">Common questions.</h1>
      <p className="mt-8 text-[#555] max-w-xl text-lg">Answers to the questions we're asked most often. Don't see yours? <a href="/contact" className="text-[#C5A059] font-bold">Get in touch.</a></p>
      {categories.map(cat => (
        <div key={cat} className="mt-16">
          <p className="text-xs font-mono tracking-[0.3em] uppercase text-[#C5A059] mb-6">{cat}</p>
          <div className="divide-y divide-[#E5E5E5] border-t border-b border-[#E5E5E5]">
            {(grouped[cat] || []).map(f => (
              <details key={f.id} className="group py-6" data-testid={`faq-item-${f.id}`}>
                <summary className="cursor-pointer flex items-start justify-between gap-6 list-none">
                  <span className="font-serif text-xl md:text-2xl">{f.question}</span>
                  <span className="text-[#C5A059] font-mono text-2xl group-open:rotate-45 transition-transform">+</span>
                </summary>
                <p className="text-[#555] mt-4 leading-relaxed">{f.answer}</p>
              </details>
            ))}
          </div>
        </div>
      ))}
    </section>
  );
}
